import React from "react";

const SuccessIcon = () => {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45 0C20.19 0 0 20.19 0 45C0 69.81 20.19 90 45 90C69.81 90 90 69.81 90 45C90 20.19 69.81 0 45 0ZM45 86C22.39 86 4 67.61 4 45C4 22.39 22.39 4 45 4C67.61 4 86 22.39 86 45C86 67.61 67.61 86 45 86ZM67.41 29.59C68.19 30.37 68.19 31.64 67.41 32.42L39.41 60.42C39.02 60.8 38.51 61 38 61C37.49 61 36.98 60.8 36.59 60.41L22.59 46.41C21.81 45.63 21.81 44.36 22.59 43.58C23.37 42.8 24.64 42.8 25.42 43.58L38 56.17L64.59 29.58C65.37 28.8 66.63 28.8 67.41 29.59Z"
        fill="#4C8991"
      />
    </svg>
  );
};

export default SuccessIcon;
